import EventTable from 'src/features/events/components/EventTable';

const FullLog = () => {
    return <EventTable />;
};

export default FullLog;
